<div class="tw-mt-12 xs:tw-mt-6">
  <ng-content select="[header]"></ng-content>
  <ng-content select="[content]"></ng-content>
  <ng-content select="[footer]"></ng-content>
</div>
